import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { FieldMetaType } from '@/types/myVaultTypes';

export const getVaultAccountIncrementalFieldsApi = (
  id: string,
  rails: string[]
): Promise<ApiResponseType<{ fields: Omit<FieldMetaType, 'rails'>[] }>> => {
  return authApiService.GET(`/my-vault/accounts/${id}/incremental-fields/`, { rails: rails.join(',') });
};
